<template>
  <div class="response">
    <h2>Response from {{ activeResponse.user_full_name || 'Anonymous' }} on {{ formatDateLong(activeResponse.updated_at) }}</h2>
    <template v-if="activeResponse.formatted_response">
      <survey-response :pages="activeResponse.formatted_response.pages"></survey-response>
    </template>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import DateFormatter from '@/mixins/date';
  import SurveyResponse from '@/components/survey/Response';

  export default {
    name: 'admin-survey-response',

    components: { SurveyResponse },

    mixins: [DateFormatter],

    computed: {
      ...mapGetters('admin', [
        'activeSurvey',
        'activeResponse',
      ]),
    },
  };
</script>
